import { ArrowDown, CalendarCheck2, CircleCheck, FileText } from "lucide-react";
import { Badge } from "../Badge";
import { Card, CardContent } from "../Card";
import { includedAreas, levels, problems } from "../../data/aquagym";
export function ProblemsSection() {
  const problemColumns = [problems.slice(0, 4), problems.slice(4, 8)];
  return <section className="bg-[#F8FAFC] px-5 py-10 sm:px-8 sm:py-12 lg:px-10" data-id="element-145" data-mp="2th9til5kunzc">
      <div className="mx-auto w-full max-w-6xl" data-id="element-146" data-mp="2xibnamgq67tx">
        <h2 className="mx-auto max-w-4xl text-center font-heading text-3xl font-black leading-tight tracking-tight text-[#0C4A6E] sm:text-4xl" style={{
        fontSize: "20px"
      }} data-id="element-147" data-mp="2xhk3e8whpyjh">
          Si sos instructora/instructor de Aquagym en Argentina, <span className="text-[#E11D48]" data-id="element-148" data-mp="3cf2l4rar3bhf">ESTO TE VA A SONAR FAMILIAR:</span>
        </h2>
        <div className="mt-7 grid gap-3 md:grid-cols-2 md:gap-4" data-id="element-149" data-mp="3ccq7urfxtpap">
          {problemColumns.map((column, columnIndex) => <ol key={columnIndex} start={columnIndex * 4 + 1} className="space-y-3" data-id="element-150" data-mp="1i0ry8odpurea" data-mpi={columnIndex}>
              {column.map((problem, index) => {
            const problemNumber = columnIndex * 4 + index + 1;
            return <li key={problem} className="flex items-center gap-3 rounded-xl border border-[#E2E8F0] bg-white px-3.5 py-3 shadow-[0_4px_14px_rgba(15,23,42,0.04)] sm:px-4" data-id="element-151" data-mp="37523cfusk6z3" data-mpi={index}>
                    <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-[#FDE4E4] font-mono text-base font-black text-[#E11D48]" data-id="element-152" data-mp="2x7e7fmlg8tfc">
                      {String(problemNumber).padStart(2, "0")}
                    </span>
                    <span className="text-sm font-semibold leading-5 text-[#334155] sm:text-[15px]" data-id="element-153" data-mp="3pxd2bymbrkrx">{problem}</span>
                  </li>;
          })}
            </ol>)}
        </div>
        <div className="mx-auto mt-6 flex max-w-2xl flex-col items-center rounded-2xl bg-[#0C4A6E] px-5 py-5 text-center text-white shadow-[0_10px_28px_rgba(8,145,178,0.18)]" data-id="element-154" data-mp="3gw51p9wc67uo">
          <ArrowDown className="mb-2 size-5 text-[#67E8F9]" aria-hidden="true" data-id="element-155" data-mp="25gggoo2n7iwi" />
          <p className="text-lg font-black leading-snug sm:text-xl" data-id="element-156" data-mp="25iksds6s9m7c">¿Cuántas clases más vas a improvisar al borde de la pileta?</p>
        </div>
      </div>
    </section>;
}
export function ProductPresentationSection() {
  return <section className="relative overflow-hidden bg-[#0C4A6E] px-5 py-16 text-white sm:px-8 sm:py-20 lg:px-10" data-id="element-157" data-mp="1wzg208qqvfle">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(34,211,238,0.20),transparent_35%),linear-gradient(140deg,#0C4A6E_0%,#075985_100%)]" aria-hidden="true" data-id="element-158" data-mp="21xhoz4rajz25" />
      <div className="relative mx-auto w-full max-w-6xl text-center" data-id="element-159" data-mp="1sy4d65fp2ye9">
        <Badge className="border border-cyan-300/40 bg-cyan-300/10 px-3 py-1.5 text-[11px] font-black tracking-[0.16em] text-cyan-100 hover:bg-cyan-300/10" style={{
        fontSize: "8px"
      }} data-id="element-160" data-mp="1szfhc6d1y85w">
          SISTEMA N°1 PARA INSTRUCTORES DE AQUAGYM EN ARGENTINA
        </Badge>
        <h2 className="mt-6 font-heading text-4xl font-black tracking-[-0.04em] sm:text-5xl lg:text-6xl" data-id="element-161" data-mp="158js9gzzdr2c">AQUAGYM RESUELTO™</h2>
        <p className="mt-3 text-base font-black uppercase tracking-[0.2em] text-[#67E8F9] sm:text-lg" style={{
        fontSize: "14px"
      }} data-id="element-162" data-mp="19bpyion3fi8t">MEGAPACK — SISTEMA COMPLETO</p>
        <p className="mt-6 text-xl font-bold text-white sm:text-2xl" style={{
        fontSize: "18px",
        fontWeight: "400"
      }} data-id="element-163" data-mp="lnjkh8v31bfu">7 Tomos + 5 Bonos — Todos los niveles — Todo resuelto.</p>
        <div className="mx-auto mt-7 grid max-w-3xl grid-cols-2 gap-2.5 sm:gap-4" data-id="element-164" data-mp="umeqoky4mlj5">
          <Card className="h-full border-cyan-300/30 bg-white/[0.08] text-white shadow-none backdrop-blur" data-id="element-165" data-mp="19jxcpfjf6kmw">
            <CardContent className="flex min-h-24 items-center gap-2.5 p-3 text-left sm:min-h-28 sm:gap-4 sm:p-4" data-id="element-166" data-mp="14lm2v4t4ka4o">
              <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-[#0284C7]/25 text-[#22D3EE] sm:size-12" data-id="element-167" data-mp="1icqyzwxaaka9">
                <FileText className="size-5 sm:size-6" strokeWidth={2} aria-hidden="true" data-id="element-168" data-mp="1ebp2voynyoci" />
              </span>
              <div className="min-w-0" data-id="element-169" data-mp="1s8c2jzi03sm4">
                <strong className="block text-2xl font-black leading-none tracking-tight sm:text-3xl" data-id="element-170" data-mp="1ncdaa0tjxqgf">+300</strong>
                <span className="mt-1 block text-[11px] font-semibold leading-4 text-cyan-100 sm:text-sm" data-id="element-171" data-mp="27cx0gnc1eci9">páginas estructuradas</span>
              </div>
            </CardContent>
          </Card>
          <Card className="h-full border-cyan-300/30 bg-white/[0.08] text-white shadow-none backdrop-blur" data-id="element-172" data-mp="2g71nswryp5t1">
            <CardContent className="flex min-h-24 items-center gap-2.5 p-3 text-left sm:min-h-28 sm:gap-4 sm:p-4" data-id="element-173" data-mp="2l3s2pgs15vcv">
              <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-[#0284C7]/25 text-[#22D3EE] sm:size-12" data-id="element-174" data-mp="1ognelduw8hnp">
                <CalendarCheck2 className="size-5 sm:size-6" strokeWidth={2} aria-hidden="true" data-id="element-175" data-mp="1xfscchyms6yt" />
              </span>
              <div className="min-w-0" data-id="element-176" data-mp="22evik5qckj8d">
                <strong className="block text-2xl font-black leading-none tracking-tight sm:text-3xl" data-id="element-177" data-mp="22fwtma7d55q3">60+</strong>
                <span className="mt-1 block text-[11px] font-semibold leading-4 text-cyan-100 sm:text-sm" data-id="element-178" data-mp="38ws5ffssyptw">clases listas para dar</span>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}
const levelStyles: Record<string, {
  badge: string;
  dot: string;
}> = {
  Principiante: {
    badge: "border-green-200 bg-green-50 text-green-800",
    dot: "bg-green-500"
  },
  Intermedio: {
    badge: "border-yellow-200 bg-yellow-50 text-yellow-800",
    dot: "bg-yellow-500"
  },
  Avanzado: {
    badge: "border-rose-200 bg-rose-50 text-rose-800",
    dot: "bg-rose-500"
  },
  "Adultos Mayores": {
    badge: "border-purple-200 bg-purple-50 text-purple-800",
    dot: "bg-purple-500"
  },
  Planificación: {
    badge: "border-blue-200 bg-blue-50 text-blue-800",
    dot: "bg-blue-500"
  },
  Natatorio: {
    badge: "border-cyan-200 bg-cyan-50 text-cyan-800",
    dot: "bg-cyan-500"
  },
  Gimnasio: {
    badge: "border-cyan-200 bg-cyan-50 text-cyan-800",
    dot: "bg-cyan-500"
  }
};
export function SystemOverviewSection() {
  const levelRows = [levels.slice(0, 3), [levels[3], levels[4], "Natatorio"], ["Gimnasio"]];
  return <section className="bg-[#0C4A6E] px-4 pb-8 pt-3 sm:px-8 sm:pb-10 lg:px-10" data-id="element-179" data-mp="3tcwglbmxsngn">
      <div className="mx-auto w-full max-w-6xl rounded-[24px] border border-white/60 bg-white px-4 py-5 shadow-[0_20px_50px_rgba(0,0,0,0.12)] sm:px-7 sm:py-6 lg:px-10" data-id="element-180" data-mp="3tatis5fjlq1d">
        <h2 className="text-center font-heading text-base font-black tracking-tight text-[#0C4A6E]" data-id="element-181" data-mp="3jgb9mkrcx2a6">
          Funciona desde hoy mismo en tu pileta
        </h2>

        <div className="mt-4" data-id="element-182" data-mp="fxi0ql9ix1mc">
          <h3 className="text-center text-[11px] font-black uppercase tracking-[0.1em] text-[#94A3B8]" data-id="element-183" data-mp="fzb6lycbbhta">Niveles y enfoques incluidos</h3>
          <div className="mx-auto mt-2.5 flex max-w-3xl flex-col items-center gap-1.5" data-id="element-184" data-mp="kuqhqiixqzm0">
            {levelRows.map((row, rowIndex) => <div key={rowIndex} className="flex w-full items-center justify-center gap-1.5 sm:gap-2" data-id="element-185" data-mp="ayn9cuxhq4qm" data-mpi={rowIndex}>
                {row.map(level => {
              const styles = levelStyles[level];
              return <span key={level} className={`inline-flex min-w-0 items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-extrabold sm:px-3 sm:text-xs ${styles.badge}`} data-id="element-186" data-mp="2vpno2woiqe55">
                      <span className={`size-1.5 shrink-0 rounded-full ${styles.dot}`} aria-hidden="true" data-id="element-187" data-mp="2j6sbznxt8hlj" />
                      {level}
                    </span>;
            })}
              </div>)}
          </div>
        </div>

        <div className="mt-4 border-t border-[#F1F5F9] pt-4" data-id="element-188" data-mp="2t5rawesrwyvc">
          <h3 className="text-center text-[11px] font-black uppercase tracking-[0.1em] text-[#94A3B8]" data-id="element-189" data-mp="25f55kva5lsp1">Todo lo que vas a dominar</h3>
          <div className="mx-auto mt-2.5 grid max-w-3xl grid-cols-3 gap-1.5 sm:gap-2" data-id="element-190" data-mp="20h3ky5x2xlbg">
            {includedAreas.map(area => <span key={area} className="flex min-h-8 min-w-0 items-center justify-center gap-1 rounded-lg bg-[#F1F5F9] px-1.5 py-1 text-center text-[9px] font-semibold leading-tight text-[#334155] sm:px-2.5 sm:text-[11px]" data-id="element-191" data-mp="2f5qaf0gf7tge">
                <CircleCheck className="size-3 shrink-0 text-[#06B6D4]" strokeWidth={2.5} aria-hidden="true" data-id="element-192" data-mp="1mmja4c35s44z" />
                {area}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}